<template>
  <g fill-rule="evenodd">
    <path
      d="M14.17 7.32a1.15 1.15 0 00-1.59 0L9.4 10.38 7.42 8.47a1.15 1.15 0 00-1.6 0c-.43.42-.43 1.1 0 1.53l2.79 2.68c.22.21.5.32.8.32.28 0 .57-.1.79-.32l3.97-3.83c.44-.42.44-1.1 0-1.53"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CheckIcon",
});
</script>
